import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

/**
 * RequireAdmin Guard
 * Blocks non-admin users from accessing admin-only routes
 * Redirects to access denied page (403)
 */
export default function RequireAdmin({ children }) {
  const { role } = useAuth();

  if (role !== 'admin') {
    return <Navigate to="/403" replace />;
  }

  return children;
}
